import React, { useEffect, useState, useRef } from "react";
import "./tamperProofGraph.css";

const cards = [
  {
    id: 1,
    heading: "Detect Hidden Edits",
    desc: "Identify forged text with pinpoint accuracy, before it costs you.",
    cardImg: "/images/Document OCR (1).svg",
    img: "/images/file1.svg",
  },
  {
    id: 2,
    heading: "Validate Digital Signatures",
    desc: "Digital signature validation with public–private key hash matching ensures secure PDF verification.",
    cardImg: "/images/Signature.svg",
    img: "/images/file2.svg",
  },
  {
    id: 3,
    heading: "Block Embedded Threats",
    desc: "Stop malware or hidden files inside PDFs that bypass standard document verification software.",
    cardImg: "/images/Block Thread.svg",
    img: "../images/file3.svg",
  },
  {
    id: 4,
    heading: "Scale with confidence",
    desc: "Run bulk uploads and analytics to verify hundreds of documents seamlessly.",
    cardImg: "/images/Bulk Ypload.svg",
    img: "../images/file4.svg",
  },
  {
    id: 5,
    heading: "Precision Edit Mapping",
    desc: "Tracks pixel-level changes and editor style variations to uncover even the most subtle structural edits.",
    cardImg: "/images/Edit Mapping.svg",
    img: "../images/file5.svg",
  },
];

const TamperProofGraph = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false
  );
  const rowRef = useRef(null);
  const wrapperRef = useRef(null);
  const [highlightStyle, setHighlightStyle] = useState({});

  // Detect resize to toggle mobile mode
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto change active card
  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => {
        const nextIndex = prev + 1;
        // If we've reached the end, go back to start
        if (nextIndex >= cards.length) {
          return 0;
        }
        return nextIndex;
      });
    }, 2000);
    return () => clearInterval(timer);
  }, []);

  // Update highlight & scroll active card into view
  useEffect(() => {
    const row = rowRef.current;
    const wrapper = wrapperRef.current;
    if (!row || !wrapper) return;

    const cardEls = row.querySelectorAll(".graph-card");
    const activeCard = cardEls[activeIndex];

    if (activeCard) {
      // Calculate highlight position
      const cardRect = activeCard.getBoundingClientRect();
      // const rowRect = row.getBoundingClientRect();
      // const wrapperRect = wrapper.getBoundingClientRect();

      // Position relative to the row element
      const leftPosition = activeCard.offsetLeft;

      setHighlightStyle({
        width: cardRect.width + "px",
        height: cardRect.height + "px",
        transform: `translateX(${leftPosition}px)`,
      });

      // Scroll the wrapper to center the active card (mobile only)
      if (isMobile) {
        const cardCenter = activeCard.offsetLeft + activeCard.clientWidth / 2;
        const wrapperCenter = wrapper.clientWidth / 2;
        const scrollPosition = cardCenter - wrapperCenter;

        wrapper.scrollTo({
          left: Math.max(0, scrollPosition),
          behavior: "smooth",
        });
      } else {
        // On desktop, when resetting to first card, scroll wrapper to start
        if (activeIndex === 0) {
          wrapper.scrollTo({
            left: 0,
            behavior: "smooth",
          });
        }
      }
    }
  }, [activeIndex, isMobile]);

  return (
    <div className="tamper-graph-container">
      <h1 className="graph-heading">
        Forgery Ends Where <span>TamperProof</span> Begins
      </h1>
      <p className="graph-subheading">
        Detect fraud earlier, validate authenticity faster, and secure workflows
        across every PDF with our advanced document verification software.
      </p>

      {/* wrapper is scrollable in mobile */}
      <div
        className={`graph-card-scroll-wrapper ${
          isMobile ? "mobile-scroll" : ""
        }`}
        ref={wrapperRef}
      >
        <div className="graph-card-row" ref={rowRef}>
          <div className="highlight-box" style={highlightStyle}></div>
          {cards.map((card, i) => (
            <div
              key={card.id}
              className={`graph-card ${i === activeIndex ? "graphactive" : ""}`}
            >
              <img src={card.cardImg} alt="" />
            </div>
          ))}
        </div>
        <div className="arrow-image">
          <img src="/images/Arrows.svg" alt="" />
        </div>
      </div>

      <div className="graph-image-container">
        <div className="graph-container-content">
          <h3>
            <span className="first-word">
              {cards[activeIndex].heading.split(" ")[0]}
            </span>{" "}
            {cards[activeIndex].heading.split(" ").slice(1).join(" ")}
          </h3>
          <p>{cards[activeIndex].desc}</p>
        </div>
        <img src={cards[activeIndex].img} alt="active display" />
      </div>
    </div>
  );
};

export default React.memo(TamperProofGraph);
